module.exports = {
	sourcemaps: true,
	devspecs: false,
	production: true,
	reloadless: false,
	buildConfig: {
		language: 'ru',
		server: 'https://test.case.one',
		login: 'user1@user.ru',
		password: '123123',
		port: 9000,
		https: true,
		proxyTargets: ['/api', '/authentication', '/signalr', '/account', '/notificationHub'],
		webSockets: ['/signalr', '/notificationHub'],
		isLocalServer: true
	},
	userData: {
		IsGuest: false,
		// актуальные гостевые куки для СК/КК нужно скопировать из браузера (DevTools/Application/Cookies), пройдя по сгенерированной гостевой ссылке
		GuestCookieName: '.AspNetCore.Cookies.meetings',
		GuestCookieValue: '',
		// не нужно менять, одинаковы для всех гостевых кук
		GuestCookieOptions: 'domain=localhost; path=/; max-age=1209600; secure; samesite=lax;'
	}
};
